import React, { useContext } from 'react'
import { Button, Icon } from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { SHARE_OPTIONS } from '../constants'
import i18nInstance from '../i18n/i18nInstance'
import { openSocialMediaDialog, openEmailDialog } from '../lib'
import ShareContext from '../provider/ShareContext'

const { FACEBOOK, MESSENGER, LINKEDIN, TWITTER, EMAIL } = SHARE_OPTIONS

type ShareModalButtonsProps = {
  links: {
    email: string
    facebook: string
    messenger: string
    twitter: string
    linkedin: string
  }
  email: {
    subject: string
    body: string
  }
  onClose: () => void
}

const ShareModalButtons = ({
  links,
  email,
  onClose,
}: ShareModalButtonsProps) => {
  const { t } = useTranslation('@mc/share')
  const shareData = useContext(ShareContext)

  const onClickSocialMediaButton = (channel: string, link: string) => {
    if (shareData === null) {
      return
    }

    openSocialMediaDialog({ channel, link, shareData })
    onClose()
  }

  const onClickEmailButton = () => {
    if (!shareData?.course) {
      return
    }

    openEmailDialog({
      link: links.email,
      subject: email.subject,
      body: email.body,
      shareData,
    })
    onClose()
  }

  return (
    <div
      className='d-flex justify-content-between mc-my-7'
      data-testid='share-buttons'
    >
      <Button
        kind='facebook'
        className='mc-px-5'
        onClick={() => onClickSocialMediaButton(FACEBOOK, links.facebook)}
        data-testid='facebook-button'
      >
        <Icon
          kind='facebook'
          srText={t('a11y.shareButton', { network: FACEBOOK })}
        />
      </Button>

      <Button
        kind='messenger'
        className='mc-px-5'
        onClick={() => onClickSocialMediaButton(MESSENGER, links.messenger)}
        data-testid='messenger-button'
      >
        <Icon
          kind='messenger'
          srText={t('a11y.shareButton', { network: MESSENGER })}
        />
      </Button>

      <Button
        kind='linked-in'
        className='mc-px-5'
        onClick={() => onClickSocialMediaButton(LINKEDIN, links.linkedin)}
        data-testid='linkedin-button'
      >
        <Icon
          kind='linked-in'
          srText={t('a11y.shareButton', { network: LINKEDIN })}
        />
      </Button>

      <Button
        kind='twitter'
        className='mc-px-5'
        onClick={() => onClickSocialMediaButton(TWITTER, links.twitter)}
        data-testid='twitter-button'
      >
        <Icon
          kind='twitter'
          srText={t('a11y.shareButton', { network: TWITTER })}
        />
      </Button>

      <Button
        kind='tertiary'
        className='mc-px-5'
        onClick={onClickEmailButton}
        data-testid='email-button'
      >
        <Icon kind='mail' srText={t('a11y.shareButton', { network: EMAIL })} />
      </Button>
    </div>
  )
}

export default withI18nContext(i18nInstance)(ShareModalButtons)
